'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _FrameEventBusContainer = require('../globals/FrameEventBusContainer');

var _FrameEventBusContainer2 = _interopRequireDefault(_FrameEventBusContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handleFrameRedirect = function handleFrameRedirect(maybePromiseRedirect) {
  var maybePromiseRedirectUrl = [maybePromiseRedirect];
  Promise.all(maybePromiseRedirectUrl).then(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        url = _ref2[0];

    return _FrameEventBusContainer2.default.get().sendRedirectMessage(url);
  });
};

exports.default = handleFrameRedirect;
module.exports = exports['default'];